module.exports = __webpack_public_path__ + "img/mouse_illustration_desktop.c1decb79.png";